import React, { FC, ReactNode } from 'react';
import theme from 'src/utils/theme';
import { useMediaQuery } from 'react-responsive';
import { RuleSet } from 'styled-components';
import Footer from '../Footer';
import SkipToContent from '../SkipToContent';
import * as S from './styles';

interface Props {
  header?: ReactNode;
  sidebar?: ReactNode;
  mobileNavBar?: ReactNode;
  footerStyle?: 'none' | 'full';
  contentBackground?: RuleSet<object>;
  children?: ReactNode;
}

export const PageContentWrapper: FC<Props> = ({ children }) => {
  return <S.PageContent>{children}</S.PageContent>;
};

export const PageWithSidebar: FC<Props> = ({
  children,
  header,
  sidebar,
  mobileNavBar,
  footerStyle = 'full',
  contentBackground,
}) => {
  const showMobileNavBar = useMediaQuery({
    maxWidth: theme.sz.maxMobileBreakpoint,
  });

  return (
    <S.OuterContainer $showMobileNavBar={showMobileNavBar}>
      <SkipToContent />
      {!showMobileNavBar && <S.Sidebar data-testid="sidebar">{sidebar}</S.Sidebar>}
      <S.HeaderContainer>{header}</S.HeaderContainer>
      <S.ContentArea id="main-content" $background={contentBackground}>
        <PageContentWrapper>{children}</PageContentWrapper>
        {footerStyle !== 'none' && <Footer />}
      </S.ContentArea>
      {showMobileNavBar && <S.MobileNavBar>{mobileNavBar}</S.MobileNavBar>}
    </S.OuterContainer>
  );
};

export default PageWithSidebar;
